



















import {Vue, Component, Prop} from 'vue-property-decorator';
import SearchHold from "@/domainObjects/hold/SearchHold";
import Verification from "@/domainObjects/hold/Verification";
import HoldActionItems from "@/domainObjects/hold/HoldActionItems";

@Component({
})

export default class VerificationPicker extends Vue {
    @Prop({required: false}) item!: HoldActionItems;
    @Prop({required: false}) selectMultiple!: Boolean;
    @Prop({required: false}) search!: SearchHold;

    private verifications: ({ text: string; value: number })[] = [];

    constructor(){
        super();
        this.verifications = [
            {value: 1, text:"Good"},
            {value: 2, text:"Scrap"},
            {value: 3, text:"Further Action Required (New Ticket)"},
            {value: 4, text:"Returned"},
        ]
    }
}
